import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Circle from 'ol/style/Circle';
import RegularShape from 'ol/style/RegularShape';
import Text from 'ol/style/Text';

import Point from 'ol/geom/Point';

import { to_rgb } from '../../util/colour';

const getMark = (name, size, fill, stroke) => {
	const radius =  (size / 2) || 10;

	switch(name) {
		case 'circle':
			return new Circle({
			    fill: fill,
			    stroke: stroke,
			    radius: radius
			});
		case 'triangle':
			return new RegularShape({
				fill: fill,
				stroke: stroke,
				points: 3,
				radius: radius,
				angle: 0
			});
		case 'star':
			return new RegularShape({
				fill: fill,
				stroke: stroke,
				points: 5,
				radius: radius,
				radius2: (4 / 10) * radius,
				angle: 0
			});
		case 'cross':
			return new RegularShape({
				fill: fill,
				stroke: stroke,
				points: 4,
				radius: radius,
				radius2: 0,
				angle: 0
			});
		case 'x':
			return new RegularShape({
				fill: fill,
				stroke: stroke,
				points: 4,
				radius: radius,
				radius2: 0,
				angle: Math.PI / 4
			}); 
		case 'square':
		default:
			return new RegularShape({
				fill: fill,
				stroke: stroke,
				points: 4,
				radius: radius,
				angle: Math.PI / 4
			});
	}
};

const getLineText = (text) => {
	return new Text({
        	text: text,
        	placement: "line",
        	font: "16px sans-serif",
        	fill: new Fill({
        		color: '#000000'
        	}),
        	stroke: new Stroke({
        		color: '#fff',
        		width: 3
        	})        	
        });	
};

const sketchLabel = options => {
	const fill = new Fill({
		color: to_rgb(options.fill)
	});
	
	const text = new Text({
		text: options.text,
		fill: fill,
		rotation: options.rotation,
		font: options.font
	});
	
	return new Style({
		text: text
	});
	
}	

const sketchStyle = (options) => {
	const fill = new Fill({
		color: to_rgb(options.fill)
	});
	
	const stroke = new Stroke({
		color: to_rgb(options.stroke),
		width: options.strokeWidth || 1
	});
	
	if( options.geometry instanceof Point ) {
		let image = getMark(options.mark, options.markSize, fill, stroke);
		return new Style({
				image: image
			});
	
	} else {
		let text = null;
		if( options.lineLength ) {
			text = getLineText(options.lineLength);
		}
		
		return new Style({
			fill: fill,
			stroke: stroke,
			text: text,
		});
	}


};

export { sketchStyle, sketchLabel };
